const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/backend/user`;

export default API_BASE_URL;
